import { IconButton, Paper } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Button } from "../../../controls";
import {
  ArrowBackRounded,
  DeleteRounded,
  FormatListBulletedRounded,
  PaymentsRounded,
} from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import { action, API, controller } from "../../../api/api";
import { Alert, Dialog } from "../../../layout";
import PayBalanceForm from "./PayBalance/PayBalanceForm";
import { AppContext } from "App";
import { useFormatPrice } from "hooks";

const ActionWidget = ({ setReloadKey }) => {
  const { access } = useContext(AppContext);
  const formatPrice = useFormatPrice();
  const navigate = useNavigate();
  const { id } = useParams();
  const [showForm, setShowForm] = useState(false);
  const [balance, setBalance] = useState(0);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  const GetBalance = () => {
    API(controller.CustomerTxn + action.CustomerDue).getById(id, (res) => {
      res && res.status === 200
        ? setBalance(res.result || 0)
        : console.error("Error: ", res);
    });
  };

  useEffect(() => {
    GetBalance();
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleBack = () => {
    navigate(-1);
  };

  const handlePayBalance = () => {
    setShowForm(true);
  };

  const handleDlt = () => {
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: "Are you sure!",
      subTitle: "You want to delete this customer profile?",
      onConfirm: () => {
        const onComplete = (res) => {
          if (res && res.status === 200) {
            setAlert({
              isOpen: true,
              type: "success",
              title: "Deleted Successfully",
              subTitle: res.msg,
              onClick: () => handleBack(),
            });
          } else {
            setAlert({
              isOpen: true,
              type: "warning",
              title: "Warning",
              subTitle: res.msg,
            });
          }
        };
        API(controller.Customer).Delete(id, onComplete);
      },
    });
  };

  const handleViewSale = () => {
    navigate(`/sales_history/${id}`);
  };

  return (
    <>
      <Paper className="flex gap-3 justify-between p-[5px] mb-[10px]">
        <IconButton onClick={handleBack} size="small">
          <ArrowBackRounded />
        </IconButton>

        <div className="flex flex-wrap gap-2">
          <Button
            onClick={handleViewSale}
            variant="text"
            startIcon={<FormatListBulletedRounded />}
          >
            View Sales
          </Button>
          {access?.customer?.receivePayment && balance > 0 && (
            <Button
              onClick={handlePayBalance}
              variant="text"
              startIcon={<PaymentsRounded />}
            >
              Pay account balance ({formatPrice(balance)})
            </Button>
          )}
          {access?.customer?.delete && (
            <Button
              onClick={handleDlt}
              variant="text"
              className="!bg-red-50 !text-red-500"
              startIcon={<DeleteRounded />}
            >
              Delete Customer
            </Button>
          )}
        </div>
      </Paper>

      {/* Payblanace Form */}
      {showForm && (
        <Dialog show={showForm} onClose={false} maxWidth="sm">
          <PayBalanceForm
            {...{
              setShowForm,
              setAlert,
              customerId: id,
              balance,
              GetBalance,
              setReloadKey,
            }}
          />
        </Dialog>
      )}

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default ActionWidget;
